import {Activity, ActivityType} from '../activity';
import {Definition, SimpleDefinition} from '../definition';
import {Observable} from 'rxjs';
import {ActivityPropertyDataType} from '../enumerations/activity-property-data-type';
import {LazyDialogService} from './lazy-dialog.service';

export class GenerateUniqueValueActivity extends Activity {
  public PublicationTarget: string;
  public ActivityExecutionCondition: string;
  public ConflictFilter: string;
  public QueryLdap: boolean;
  public LdapQueriesTable: Definition[];
  public UniquenessSeed: number;
  public ValueExpressions: SimpleDefinition[];

  constructor(activityNode: any, lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.GenerateUniqueValue);
    this._properties['PublicationTarget'] = ActivityPropertyDataType.STRING;
    this._properties['ActivityExecutionCondition'] = ActivityPropertyDataType.STRING;
    this._properties['ConflictFilter'] = ActivityPropertyDataType.STRING;
    this._properties['QueryLdap'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['LdapQueriesTable'] = ActivityPropertyDataType.DEFINITION_TABLE;
    this._properties['UniquenessSeed'] = ActivityPropertyDataType.INTEGER;
    this._properties['ValueExpressions'] = ActivityPropertyDataType.STRING_ARRAY;
    this.parse(activityNode);
  }

  beforeSave(): void {
    super.beforeSave();

    if (this.QueryLdap === false) {
      this.LdapQueriesTable = null;
    }
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('generate-unique-value', this.dialogConfig);
  }
}
